import { render, staticRenderFns } from "./PurchasesForm.vue?vue&type=template&id=4854ad72&"
import script from "./PurchasesForm.vue?vue&type=script&lang=js&"
export * from "./PurchasesForm.vue?vue&type=script&lang=js&"
import style0 from "./PurchasesForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports